import { API_BASE_URL } from '../../config/api';

export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  if (!token) return {};

  // Decode the token to check expiry
  const tokenData = parseJwt(token);
  if (tokenData && isTokenExpiringSoon(tokenData.exp)) {
    refreshAuthToken(); // Refresh asynchronously
  }

  return { Authorization: `Bearer ${token}` };
};

const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1]; // JWT payload is in second part
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error('Failed to parse JWT:', error);
    return null;
  }
};

const isTokenExpiringSoon = (exp: number): boolean => {
  const expirationTime = exp * 1000; // Convert seconds to milliseconds
  const currentTime = Date.now();
  return expirationTime - currentTime <= 5 * 60 * 1000; // Less than 5 mins
};

const refreshAuthToken = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/refreshToken`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: localStorage.getItem('authToken') }),
    });

    if (!response.ok) {
      throw new Error('Failed to refresh token');
    }

    const data = await response.json();
    localStorage.setItem('authToken', data.token);
    console.log('Token refreshed successfully');
  } catch (error) {
    console.error('Error refreshing token:', error);
  }
};
